import { SensorAlerts } from "@station/domain/models/sensor-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class SensorAlertGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(stationId: string): Promise<SensorAlerts> {
        const sensorAlertResult =
            await this.alertRepository.getAllSensorAlert(stationId);

        return sensorAlertResult.match(
            (sensorAlerts) => sensorAlerts,
            () => SensorAlerts.empty(),
        );
    }
}
